import { Routes, Route, Navigate } from 'react-router-dom';
import ModuleLayout from '../../layout/ModuleLayout';
import { useTranslation } from 'react-i18next';
import {
  FaSave,
} from 'react-icons/fa';

import BackupsPage from '../Backups/BackupsPage';

const BackupsModule = () => {
  const { t } = useTranslation();

  const moduleConfig = {
    id: 'backups',
    title: t('modules.backups.title'),
    description: t('modules.backups.description'),
    icon: FaSave,
    color: '#115c9eff',
    menuItems: [
      { path: '/backups-module/backups', icon: FaSave, label: t('nav.backups') }
    ]
  };

  return (
    <ModuleLayout moduleConfig={moduleConfig}>
      <Routes>
        <Route path="/" element={<Navigate to="/backups-module/backups" replace />} />
        <Route path="/backups" element={<BackupsPage />} />
      </Routes>
    </ModuleLayout>
  );
};

export default BackupsModule;
